import React, { useRef, useState, useEffect,} from 'react';
import {Card, Button, CardText, Nav, NavLink } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


function Home({ currentPage, handlePageChange }) {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [showBottom, setShowBottom] = useState(false);
  

    useEffect(() => {
  const t = setTimeout(() => setShowBottom(true), 300); // fades in earlier or later, your choice
  return () => clearTimeout(t);
}, []);

  
    useEffect(() => {
      if (videoRef.current) {
        setMuted(videoRef.current.muted);
      }
    }, []);

const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  
  return (
<>
<div
style={{
marginBottom: '10%'
}}
>
      <video
    
    autoPlay
    // loop
    muted
    playsInline
    preload="auto"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -1,
      
      
    }}
    >  

    <source src={`${CF_BASE}/public/fire.mp4`} type="video/mp4" />
  </video>
    {/* wrapper so overlays move with video */}
    <div 
     style={{ 
      position: "relative", 
       width: "80%",
      maxWidth: "650px",
      maxHeight: "90vh",    
      margin: "0 auto",
      }}>

      {/* Centered video */}
      <div>
              <video
        playsInline
        autoPlay
        muted
        preload="metadata"
            style={{
            width: "80%",
            maxWidth: "650px",
            display: "block",
            margin: "2% auto 5% auto",  
            objectFit: "cover",
            zIndex: 0,
             backgroundColor: 'rgba(0, 0, 0, 0.4)',
        maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
        
          }}
        ref={videoRef}
      >
        <source src={`${CF_BASE}/public/BKNF.mp4`} type="video/mp4" />
      </video>
      </div>
    </div>

    <div
        style={{
  marginBottom: '2%'
}}
    >
      <h2
  style={{
    position: "relative",
    left: "50%",
    transform: showBottom
      ? "translateX(-50%)" // centered above card
      : "translateX(-150%)", // start off left
    display: "inline-block",
    fontWeight: "bold",
    padding: "0.2rem 0.6rem",
    opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease, transform 0.6s ease",
  }}
>
  EPIC ACTION. UNSTOPPABLE STORIES.
</h2>


<Card
  style={{
    maxWidth: "750px",
    margin: "0 auto",
    padding: "0 1rem", 
    textAlign: "center",
    opacity: showBottom ? 1 : 0,
    border: '2px solid rgb(179, 37, 25)',
    transitionDelay: ".2s",
    transform: showBottom ? "translateX(0)" : "translateX(100%)",
    transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.3s",
    backgroundColor: 'transparent', // card itself has no background
  }}
>
  <CardText
    className='home-tag'
  style={{
    fontWeight: "bold",
    color: "silver",
  }}
  >
    <div
    style={{
  marginBottom: '2%'
}}>
       From the mind of Robert Rodriguez comes Brass Knuckle Films — 
    the fan-powered action label that's rewriting the rules. With 
    our Warrior community of investors behind us, we're developing 
    a slate of high-impact films: franchise-ready stories packed 
    with adrenaline, ingenuity, and pure grit.
    </div>


    <div
    style={{
  marginBottom: '2%'
}}
    >
      No massive budgets needed. Just raw creativity and unstoppable drive.
    </div>

    <div>
          We're in production mode now — turning ideas (including investor pitches) 
    into reality. Join the fight.
    </div>
   
  </CardText>
</Card>
    </div>

<div>
      <h2
  style={{
    position: "relative",
    left: "50%",
    transform: showBottom
      ? "translateX(-50%)" // centered above card
      : "translateX(-150%)", // start off left
    display: "inline-block",
    fontWeight: "bold",
    
 
    opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease, transform 0.6s ease",
  }}
>
    GET A PIECE OF THE ACTION!
</h2>


<Card
  style={{
    maxWidth: "600px",
    margin: "0 auto",
    textAlign: "center",
    opacity: showBottom ? 1 : 0,
    border: '2px solid rgb(179, 37, 25)',
    transitionDelay: ".2s",
    transform: showBottom ? "translateX(0)" : "translateX(100%)",
    transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.3s",
    clipPath: "polygon(0 50%, 20px 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 20px 100%)",
    backgroundColor: 'transparent', // card itself has no background
  }}
>
  <CardText
    className='home-tag'
  style={{
    fontWeight: "bold",
    color: "silver",
  }}
  >
        Grab the latest gear at our official store:
  </CardText>
</Card>

      <div className='hover-brighten-home'
  style={{
    position: "relative",
    marginTop: '1%',
        left: "50%",
    transform: showBottom
      ? "translateX(-50%)" // centered above card
      : "translateX(-150%)", // start off left
          opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease, transform 0.6s ease",
    display: "inline-block",
    fontWeight: "bold",
    // padding: "0.2rem 0.6rem",
    backgroundColor: 'rgba(20,19,19,0.9)',
    borderRadius: '12px',
    border: '2px solid rgb(179,37,25)',
    boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
         WebkitTextFillColor: 'rgb(227, 153, 16)'
  }}
>
    <Nav>
        <Nav.Link className="custom-nav-link" 
            onClick={() => {
              handlePageChange('BKFMerchShop');
              navigate('/BKFMerchShop');
            }}
            className={currentPage === 'BKFMerchShop' ? 'nav-link active' : 'nav-link'}
        >
          <h2 style={{ margin: 0 }}>Brass Knuckle Shop</h2>
        </Nav.Link>
      </Nav>
</div>
    </div>
<div>
</div>
</div>
  </>
  );
}

export default Home;
